import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import React, { PropsWithChildren, useContext } from "react";
import BotSummaryTabsValuesProvider from "@shared/features/bots/BotForm/common/hooks/BotSummaryTabsValuesProvider";
import { BotFormType } from "@shared/features/bots/BotForm/common/types";
import BulkEditBotsValuesProvider from "@shared/features/bots/BotForm/common/BulkEditBotsValuesProvider";
import BulkCreateBotsValuesProvider from "@shared/features/bots/BotForm/common/BulkCreateBotsValuesProvider";

const AdditionalBotValuesProvider = ({ children }: PropsWithChildren) => {
  const botFormContextValues = useContext(BotFormContext)!;
  const { botFormType, showBacktesting, showPublicBots } = botFormContextValues;

  let finalContent = children;
  if (botFormType === BotFormType.BULK_EDIT) {
    finalContent = (
      <BulkEditBotsValuesProvider>{finalContent}</BulkEditBotsValuesProvider>
    );
  } else if (botFormType === BotFormType.BULK_CREATE) {
    finalContent = (
      <BulkCreateBotsValuesProvider>
        {finalContent}
      </BulkCreateBotsValuesProvider>
    );
  }
  if (showBacktesting || showPublicBots) {
    finalContent = (
      <BotSummaryTabsValuesProvider>
        {finalContent}
      </BotSummaryTabsValuesProvider>
    );
  }

  return <>{finalContent ?? null}</>;
};

export default AdditionalBotValuesProvider;
